import { createContext, useContext } from "react";
import useDiscoveryDefinition from "../hooks/useDiscoveryDefinition";

const DiscoveryDefinitionContext = createContext(null);

export const DiscoveryDefinitionProvider = ({ children }) => {
    const value = useDiscoveryDefinition();
    return <DiscoveryDefinitionContext.Provider value={value}>
        {children}
    </DiscoveryDefinitionContext.Provider>;
};

export const useDiscoveryDefinitionContext = () => {
    const context = useContext(DiscoveryDefinitionContext);

    if (!context) {
        throw new Error("useDiscoveryDefinitionContext must be used within DiscoveryDefinitionProvider");
    }

    return context;
};
